export default Object.freeze({
  TOKENS: {
    SID: 'service_kiia7gh',
    TID: 'contact_form',
    UID: 'user_9MnljMaWugBtmj5FgDHzG'
  }
})

